// extracted by mini-css-extract-plugin
module.exports = {"label":"labels_label__8Nklh","verified":"labels_verified__Ga9Ni","ready":"labels_ready__DIYo5"};